import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactTable from "react-table";
import moment from "moment";
import { DatePicker } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import ConfirmModal from "components/common/confirm-modal";
import ReactTableFilterSelect from "components/custom/forms/react-table-filter-select";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";
import WorkerProfile from "components/menu/master-files/workers-maintenance/worker-profile";
import SearchSelect from "components/common/SearchSelect";
import {
    getWorkersList
} from "api/menu/master-files/workers-maintenance/actions";
import { openCustomModal, closeCustomModal } from "components/custom/modals";

class ReportBuilder extends React.Component {
    dateFormat = "YYYY-MM-DD";

    roles = [];

    constructor(props) {
        super(props);

        this.state = {
        };

        this.getColumns = this.getColumns.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);

        this.props.getWorkersList();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.workersList.length) {
            this.roles = {};
            nextProps.workersList.forEach(item => {
                if (!this.roles[item.role]) {
                    this.roles[item.role] = item.role;
                }
            });

            this.roles = Object.keys(this.roles).map(item => ({
                label: item,
                value: item
            }));
        }
    }

    /*
    planogramId: 2
    typeId: 124
    */
    getColumns = () => [
        {
            Header: "Employee Code",
            accessor: "employeeCode",
        },
        {
            Header: "First Name",
            accessor: "firstName",
        },
        {
            Header: "Last Name",
            accessor: "lastName",
        },
        {
            Header: "Roles",
            accessor: "role",
            headerStyle: {
                overflow: "visible"
            },
            Filter: ({ filter, onChange }) => (
                <SearchSelect
                    className="custom-react-select g-filter-select-no-padding"
                    options={this.roles}
                    isClearable={true}
                    isMulti={true}
                    isLoading={false}
                    value={filter ? filter.value : []}
                    onChange={(items) => onChange(items)}
                />
            ),
            filterMethod: (filter, row) => {
                if (!filter.value || !filter.value.length) {
                    return true;
                }
                return filter.value.map(item => item.value).indexOf(row.role) > -1;
            }
        },
        {
            Header: "Supervisor",
            accessor: "supervisorName",
        },
        {
            Header: "Date Started",
            accessor: "startedDate",
            minWidth: 150,
            Cell: ({ original }) => (original.startedDate ? moment(original.startedDate).format("YYYY-MM-DD") : ""),
            Filter: ({ filter, onChange }) => (
                <DatePicker
                    Format="YYYY-MM-DD"
                    value={filter ? filter.value : null}
                    onChange={date => onChange(date)}
                />
            )
        },
        {
            Header: "Active?",
            id: "inactive",
            accessor: original => (original.inactive ? "No" : "Yes"),
            Cell: ({ original }) => (original.inactive ? "No" : "Yes"),
            Filter: ({ filter, onChange }) => (
                <ReactTableFilterSelect
                    currentValue={filter ? filter.value : ""}
                    onChange={value => onChange(value)}
                    style={{ width: "100%", height: "100%" }}
                    optionsObject={{
                        "": "Show All",
                        YES: "Yes",
                        NO: "No"
                    }}
                />
            ),
            width: 100,
        },
        {
            Header: "Actions",
            id: "actions",
            className: "d-flex justify-content-center align-items-center",
            filterable: false,
            width: 120,
            Cell: ({ original }) => (
                <div>
                    <Button
                        variant="primary mr-2"
                        size="sm"
                        onClick={() => this.handleEdit(original.id)}
                    >
                        <FontAwesomeIcon icon="pen" />
                    </Button>
                </div>
            )
        }
    ];

    handleDelete = (planogramId) => {
        const modalObj = {
            modalSettings: {
                size: "sm",
                width: 300
            },
            header: false,
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <ConfirmModal
                        title={(
                            <div>
                                Removing planogram.<br/>
                                Are you sure?
                            </div>
                        )}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onConfirm={() => {
                            this.props.deletePlanogramById(planogramId);
                            this.props.closeCustomModal(modalObj);
                        }}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    handleEdit = (workerId = false) => {
        const modalObj = {
            modalSettings: {
                size: "lg",
                style: {
                    top: 20,
                    width: "50%",
                    // width: "calc(100% - 40px)",
                    minWidth: 1000
                },
            },
            header: `${workerId ? "Edit" : "Add"} employee`,
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <WorkerProfile
                        workerId={workerId}
                        isEditable={true}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSave={() => this.props.closeCustomModal(modalObj)}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    render() {
        const {
            loading,
            workersList
        } = this.props;

        return (
            <div className="dashboard">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="mb-0">
                        Workers Maintenance
                    </h3>
                    <button
                        className="btn btn-success"
                        onClick={() => this.handleEdit()}
                    >
                        Add New Worker
                    </button>
                </div>

                <ReactTable
                    data={workersList}
                    columns={this.getColumns()}
                    headerClassName="table-header"
                    showPagination={true}
                    defaultPageSize={20}
                    pageSizeOptions={[10, 20, 50, 100]}
                    resizable
                    className="-striped -highlight"
                    loading={loading}
                    filterable={true}
                    defaultFiltered={[
                        {
                            id: "inactive",
                            value: "YES"
                        }
                    ]}
                    defaultSorted={[{
                        id: "completedDate",
                        desc: false
                    }]}
                    defaultFilterMethod={filterCaseInsensitive}
                    getNoDataProps = {() => ({
                        style: {
                            zIndex: 0
                        }
                    })}
                    style={{
                        height: "calc(100vh - 140px)",
                    }}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.workersMaintenance.loading,
    workersList: state.workersMaintenance.workersList,
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

    getWorkersList: bindActionCreators(getWorkersList, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ReportBuilder);
